import React from 'react';
import { List } from 'antd';
import { Description } from 'components/Antd/index';
import PropTypes from 'prop-types';
import cn from 'classnames';
import T from 'i18n-react';
import classes from './Style.module.scss';
import JobStatus, { JOB_STATUS } from 'modules/inspection/components/JobStatus/index';

export default function SupplierListItem({
  name,
  address,
  contactPerson,
  emails,
  contactPersonPhone,
  supplierId,
  status,
  children,
  extra,
  className,
  hideEmail,
  hideContactPerson,
  hideContactPersonPhone,
  bordered = true,
}) {
  return (
    <List.Item className={cn(classes.supplier, className)}>
      <div className={classes.content}>
        <div
          className={cn(classes.description, {
            [classes.bordered]: bordered,
          })}>
          <Description
            title={name}
            items={[
              {
                label: T.translate('supplierID'),
                span: 3,
                children: supplierId || 'N/A',
              },
              {
                key: 'status',
                label: T.translate('general.status'),
                span: 3,
                children: (
                  <JobStatus status={status || 'inactive'}>
                    {status ? JOB_STATUS[status] : 'N/A'}
                  </JobStatus>
                ),
              },
              {
                label: T.translate('general.address'),
                span: 3,
                children: address || 'N/A',
              },
              {
                key: 'Contact Person',
                label: T.translate('general.contactPerson'),
                span: 3,
                children: contactPerson || 'N/A',
              },
              {
                key: 'Contact no.',
                label: T.translate('contactNo'),
                span: 3,
                children: contactPersonPhone || 'N/A',
              },
              {
                key: 'Email',
                label: T.translate('general.email'),
                span: 3,
                children:
                  Array.isArray(emails) && emails.length
                    ? emails.map(({ email }) => email).join(', ')
                    : 'N/A',
              },
            ].filter((item) => {
              if (item.key === 'Email' && hideEmail) {
                return false;
              }
              if (item.key === 'Contact Person' && hideContactPerson) {
                return false;
              }
              if (item.key === 'Contact no.' && hideContactPersonPhone) {
                return false;
              }
              return true;
            })}
          />
          {extra}
        </div>
        {children}
      </div>
    </List.Item>
  );
}

SupplierListItem.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.shape({ email: PropTypes.string })),
  address: PropTypes.string,
  name: PropTypes.string,
  contactPerson: PropTypes.string,
  contactPersonPhone: PropTypes.string,
  supplierId: PropTypes.string,
  bordered: PropTypes.bool,
  extra: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  hideEmail: PropTypes.bool,
  hideContactPerson: PropTypes.bool,
  hideContactPersonPhone: PropTypes.bool,
  status: PropTypes.string,
};

SupplierListItem.defaultProps = {
  emails: [], // Add defaultProps for the 'emails' prop
  bordered: true,
  extra: null,
  children: null,
  className: '',
  address: '',
  name: '',
  contactPerson: '',
  supplierId: '',
  contactPersonPhone: '',
  hideEmail: false,
  hideContactPerson: false,
  hideContactPersonPhone: false,
  status: '',
};
